<template>
	<modal v-if="!isMobileView" hide-footer size="large" @close="handleCloseModal">
		<template slot="header">
			<h3>
				<b>{{ productName }}</b>
			</h3>
		</template>
		<template slot="body">
			<div class="product-detail-image-modal-container">
				<div class="main-image-container">
					<img
						v-if="mainImage.type === 'image'"
						:src="mainImage.url"
						alt="product-image"
						class="main-image"
					/>
					<iframe
						v-else
						width="1920"
						heigth="1080"
						:src="`https://www.youtube.com/embed/${mainImage.videoUrl}`"
						:title="productName"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowfullscreen
					></iframe>
				</div>

				<div><div class="divider"></div></div>

				<div class="image-list-container">
					<div
						v-for="(image, index) in images"
						class="image-list-wrapper"
						:key="index"
						:class="{ active: image.active }"
						@click="handleSelectImage(index)"
					>
						<div v-if="image.type === 'video'" class="video-play">
							<i class="bi bi-play-fill"></i>
						</div>

						<img :src="image.url" alt="product-image" class="image-list-item" />
					</div>
				</div>
			</div>
		</template>
	</modal>

	<modal-custom v-else hide-footer size="large" @close="handleCloseModal">
		<template slot="body">
			<div
				class="product-detail-image-modal-container"
				:class="{ 'mobile-view': isMobileView }"
			>
				<div class="main-image-container" :class="{ 'mobile-view': isMobileView }">
					<img
						v-if="mainImage.type === 'image'"
						:src="mainImage.url"
						alt="product-image"
						class="main-image"
						:class="{ 'mobile-view': isMobileView }"
					/>
					<iframe
						v-else
						width="1920"
						heigth="1080"
						:src="`https://www.youtube.com/embed/${mainImage.videoUrl}`"
						:title="productName"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowfullscreen
					></iframe>
				</div>
			</div>
		</template>
	</modal-custom>
</template>

<script>
import { mapGetters } from 'vuex';

import Modal from '@/components/Modal.vue';
import ModalCustom from '@/components/ModalCustom.vue';

export default {
	components: {
		Modal,
		ModalCustom,
	},
	props: {
		images: {
			type: Array,
			default: () => [],
		},
		productName: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapGetters({
			isMobileView: 'privateOrder/isMobileView',
		}),
		mainImage() {
			// eslint-disable-next-line arrow-parens
			return this.images.find((item) => item.active === true);
		},
	},
	methods: {
		handleCloseModal() {
			this.$emit('close', false);
		},
		handleSelectImage(selectedIndex) {
			this.$emit('select-image', selectedIndex);
		},
	},
};
</script>

<style scoped lang="scss">
.product-detail-image-modal-container {
	width: 100%;
	height: 500px;
	display: flex;
	flex-direction: row;
	gap: 12px;

	&.mobile-view {
		height: auto;
		min-height: 500px;
	}
}

.image-list-container {
	width: 80px;
	min-width: 80px;
	height: 100%;
	overflow-y: auto;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
}

.image-list-wrapper {
	flex-shrink: 0;
	width: 80px;
	border-radius: 10px;
	padding: 3px;
	border: 2.5px solid transparent;
	cursor: pointer;
	position: relative;

	& > .video-play {
		position: absolute;
		z-index: 1;
		width: 40px;
		height: 40px;
		left: calc(50% - 20px);
		top: calc(50% - 20px);
		border-radius: 100%;
		background-color: #00000068;
		border: 2px solid #ffffffcd;
		color: #ffffffcd;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		padding-top: 1px;
		padding-left: 2px;
	}

	&.active {
		border: 2.5px solid #0063b5;
	}
}

img.image-list-item {
	width: 100%;
	border-radius: 8px;
	object-fit: cover;
	aspect-ratio: 1;
}

.divider {
	height: calc(100% - 16px);
	border: 0.5px solid rgba(0, 0, 0, 0.1);
	margin: 8px 0;
}

.main-image-container {
	width: 100%;
	max-width: 777px;
	height: auto;
	max-height: 500px;
	display: flex;
	justify-content: center;

	&.mobile-view {
		max-width: 100%;
	}

	& > img.main-image {
		max-height: 500px;
		border-radius: 8px;

		&.mobile-view {
			object-fit: contain;
		}
	}
}
</style>
